export const insertDashes = (
  value: string,
  isDeletingDash: boolean,
): string => {
  // We want a good user experience here, ie the user can insert dashes if they so please, otherwise it will do so for them. They can also delete dashes if they need to

  const uppercased = value.toUpperCase();
  const withOneDash = uppercased.replace(/(\w{4})/, "$1-");
  const withTwoDashes = uppercased.replace(/(\w{4})(\w{6})/, "$1-$2-");

  if (isDeletingDash && value.length <= 5) {
    return uppercased;
  }
  // 11 is the 10 characters + the first Dash
  if (isDeletingDash && value.length <= 11) {
    return withOneDash;
  }
  if (value.length >= 4 && value.length < 10) {
    return withOneDash;
  }
  if (value.length >= 10) {
    return withTwoDashes;
  }
  return uppercased;
};

export const buildUrlWithParams = ({ formInput }: { formInput: string }) => {
  const baseUrl = "/signup/";
  const params = `?pref_token=${removeDashes(formInput)}`;
  return baseUrl + params;
};

export const removeDashes = (val: string) => val.split("-").join("");
